export default "__VITE_ASSET__BWZSrXJA__"